import Vue from 'vue'
import VueRouter from 'vue-router'
//B單用頁面
import KeyinUser from '../components/toB_login/KeyinUser.vue'
import KeyinPswd from '../components/toB_login/KeyinPswd.vue'
import VerifyUser from '../components/toB_login/VerifyUser.vue'
import WebKeyinDSM from '../components/toB_login/WebKeyinDSM.vue'
import SerchDSM from '../views/toB_views/SerchDSM.vue'
import SerchDSM_D from '../views/toB_views/SerchDSM_D.vue'
import InsDSMdata from '../views/toB_views/InsDSMdata.vue'
import UpdDSMdata from '../views/toB_views/UpdDSMdata.vue'
import KeepInsDSMdata from '../views/toB_views/KeepInsDSMdata.vue'
import EndPage from '../views/toB_views/Endpage.vue'
//C單用頁面
import InsDSMdata2c from '../views/toC_views/InsDSMdata2c.vue'
import UpdDSMdata2c from '../views/toC_views/UpdDSMdata2c.vue'
import SerchDSM2c from '../views/toC_views/SerchDSM2c.vue'
import EndPage2c from '../views/toC_views/Endpage2c.vue'
import EndPageFail2c from '../views/toC_views/Endpagefail2c.vue'
//import ChoosePage2c from '../views/toC_views/ChoosePage2c.vue'
//共用畫面
import Login from '../views/Login.vue'
import ErrorPage from '../views/ErrorPage.vue'
//測試用頁面
//import Index from '../views/Index.vue'
import TestPost from '../views/TestPost.vue'
import VersionData from '../views/VersionData.vue'

Vue.use(VueRouter)

const routes = [
  //{
  //  path: '/',
  //  name: 'Index',
  //  component: Index
  //},
  {
    path: '/orderedi/Index',
    name: 'Login',
    component: Login,
    children: [{
        path: 'keyinuser',
        name: 'KeyinUser',
        component: KeyinUser
      },
      {
        path: 'keyinpswd',
        name: 'KeyinPswd',
        component: KeyinPswd
      },
      {
        path: 'verifyuser',
        name: 'VerifyUser',
        component: VerifyUser
      },
    ]
  },
  {
    path: '/orderedi/WebKeyinDSM',
    name: 'WebKeyinDSM',
    component: WebKeyinDSM
  },
  {
    path: '/orderedi/SerchDSM',
    name: 'SerchDSM',
    component: SerchDSM
  },
  {
    path: '/orderedi/SerchDSM',
    name: 'SerchDSM_D',
    component: SerchDSM_D
  },
  {
    path: '/InsDSMdata',
    name: 'InsDSMdata',
    component: InsDSMdata
  },
  {
    path: '/UpdDSMdata',
    name: 'UpdDSMdata',
    component: UpdDSMdata
  },
  {
    path: '/KeepInsDSMdata',
    name: 'KeepInsDSMdata',
    component: KeepInsDSMdata
  },
  {
    path: '/orderedi/Error',
    name: 'ErrorPage',
    component: ErrorPage
  },
  {
    path: '/orderedi/End',
    name: 'EndPage',
    component: EndPage
  },
  {
    path: '/InsDSMdata2c',
    name: 'InsDSMdata2c',
    component: InsDSMdata2c
  },
  {
    path: '/UpdDSMdata2c',
    name: 'UpdDSMdata2c',
    component: UpdDSMdata2c
  },
  {
    path: '/orderedi/SerchDSM2c',
    name: 'SerchDSM2c',
    component: SerchDSM2c
  },
  {
    path: '/orderedi/EndPage2c',
    name: 'EndPage2c',
    component: EndPage2c
  },
  {
    path: '/orderedi/Endfail2c',
    name: 'EndPagefail2c',
    component: EndPageFail2c
  },
  //{
  //  path: '/ChoosePage2c',
  //  name: 'ChoosePage2c',
  //  component: ChoosePage2c
  //},
  {
    path: '/TestPost',
    name: 'TestPost',
    component: TestPost
  },
  {
    path: '/VersionData',
    name: 'VersionData',
    component: VersionData
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
